"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCookieConsentData;
var _getCookie = _interopRequireDefault(require("../getCookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getCookieConsent = function getCookieConsent() {
  var cookieConsent = (0, _getCookie["default"])('cookie_consent');
  var _window = window,
    tcpl = _window.tcpl;
  var includesToggle = tcpl && tcpl.publicfeatures ? tcpl.publicfeatures.includes('EnableCookieConsent') : undefined;
  if (cookieConsent) {
    var _JSON$parse = JSON.parse(cookieConsent),
      analytics = _JSON$parse.analytics,
      marketing = _JSON$parse.marketing;
    return {
      analytics: analytics,
      marketing: marketing
    };
  }
  if (!cookieConsent && !includesToggle) {
    return {
      analytics: true,
      marketing: true
    };
  }
  return {
    analytics: false,
    marketing: false
  };
};
var cookieConsentData = function () {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    return getCookieConsent();
  }
  return {};
}();
function getCookieConsentData() {
  return cookieConsentData;
}